import styled from 'styled-components';

import { Loader as SemanticLoader } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Loader = styled(SemanticLoader)`
  &.ui.inline.loader { 
    display: flex;
    position: relative;
    left: 0;
    margin: 0 5px 0 15px;
  }
`;

export const Details = styled(TextLayoutComponent)`
  padding: 10px;
`;
